<template>
	<div class="doctor_item" @click="onClick">
		<div class="doctor_item_base">
			<img :src="doctor.avatar" />
			<div class="base_detail">
				<p class="name">{{doctor.name}}</p>
				<p class="department">{{doctor.deptName}} <span class="line">|</span> {{doctor.title}}</p>
				<p class="hospital">{{doctor.hospitalName}}</p>
				<p class="money" v-if="showMoney">
					<span>{{ money||0 }}</span> 元/次
				</p>
			</div>
		</div>
		<div class="doctor_item_other" v-if="doctor.introduction">
			<div class="title">个人简介</div>
			<base-ellipsis
				class="label "
				:class="{
					'van-multi-ellipsis--l2':!haveMore
				}"
				:haveMore="haveMore"
				:number="2"
				:text="doctor.introduction"
			/>
		</div>
		<div class="doctor_item_other" v-if="doctor.expertise">
			<div class="title">擅长领域</div>
			<base-ellipsis
				class="label "
				:class="{
					'van-multi-ellipsis--l2':!haveMore
				}"
				:haveMore="haveMore"
				:number="2"
				:text="doctor.expertise"
			/>
		</div>
	</div>
</template>
<script>
export default {
    name: 'DoctorItem',
    props: {
        showMoney: {
            type: Boolean,
            default: false
        },
        doctor: {
            type: Object,
            default: () => { }
        },
        haveMore: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        type () {
            return parseInt(this.$route.query.type)
        },
        money () {
            const { videoPrice, voicePrice } = this.doctor
            return this.type === 1 ? videoPrice : voicePrice
        }
    },
    methods: {
        onClick () {
            this.$emit('click')
        }
    }
}
</script>
<style lang="less" scoped>
.doctor_item {
	background-color: #ffffff;
	border-radius: 16px;
	padding: 32px 28px;
	margin-bottom: 28px;
	&_base {
		padding-bottom: 32px;
		display: flex;
		img {
			height: 132px;
			width: 132px;
			border-radius: 16px;
			margin-right: 20px;
			margin-top: 10px;
		}
		.base_detail {
			flex: 1;
			.name {
				color: #1f2329;
				font-size: 34px;
				margin-bottom: 14px;
				font-weight: bold;
			}
			.department {
				font-size: 28px;
				color: #000000;
			}
			.line {
				color: #ececec;
				margin: 0 16px;
			}
			.hospital {
				color: @gray-9;
				font-size: 26px;
				margin-top: 10px;
			}
			.money {
				font-size: 26px;
				color: #000000;
				vertical-align: bottom;
				margin-top: 16px;
				span {
					color: @primary;
					font-size: 34px;
				}
			}
		}
	}
	&_other {
		padding: 28px 0;
		border-top: 1px solid #eff0f1;
		.title {
			font-size: 30px;
			color: #000000;
			margin-bottom: 16px;
			font-weight: bold;
		}
		.label {
			font-size: 28px !important;
			color: @gray-9 !important;
		}
	}
	&_other:last-child {
		padding-bottom: 0;
	}
}
</style>